import { Usuario } from '../../../features/manutencao/usuario/models/usuario'
import { UsuarioService } from './../../../features/manutencao/usuario/usuario.service';
import { ConfigsLoaderService } from 'src/app/services/configs-loader.service';
import { EnumTipoMensagem } from 'src/app/structure/enum/enum-infra';
import { MessageInfra } from 'src/app/structure/message/message-infra';
import { MessageService } from 'src/app/structure/service/message.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanLoad } from '@angular/router';
import { JwtService } from './jwt.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private jwtService: JwtService, private messageService: MessageService, private configsLoaderService: ConfigsLoaderService,private usuarioService:UsuarioService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
  {
    if (!this.jwtService.hasToken()) {
      //this.messageService.showNotify(MessageInfra.SessaoExpirada, EnumTipoMensagem.Alerta);
      this.router.navigateByUrl('/authentication/login');
      this.jwtService.destroyToken();
      return false;
    }
    else
    {
      var tokenDados = JSON.parse(this.jwtService.getTokenDados());
      var DataExpiracaotokenDados = new Date(tokenDados.DataExpiracaoToken);
      var DateNow = new Date((new Date()).toJSON());


      if(DateNow >= DataExpiracaotokenDados)
      {
        //this.messageService.showNotify(MessageInfra.SessaoExpirada, EnumTipoMensagem.Alerta);
        this.router.navigateByUrl('/authentication/login');
        this.jwtService.destroyToken();
        return false;
      }
      else
      {
          var usuarioLogado = this.jwtService.getUsuarioDadosJSON();
          var usuarioLogadoAtualizado = new Usuario();
          this.usuarioService.getItem(usuarioLogado.Id).subscribe(res =>
          {

            usuarioLogadoAtualizado = res;

            usuarioLogado.ImagemUsuario = usuarioLogadoAtualizado.UsuarioComplemento.Imagem;

            usuarioLogado.IdEntidade = usuarioLogadoAtualizado.UsuarioComplemento.Entidade.Id;
            usuarioLogado.DescricaoEntidade = usuarioLogadoAtualizado.UsuarioComplemento.Entidade.Descricao;
            usuarioLogado.ImagemEntidade = usuarioLogadoAtualizado.UsuarioComplemento.Entidade.Imagem;

            /* VERIFICA SE O USUARIO ESTA BLOQUEADO E ATIVO A TODA ATUALIZACAO DE MENU*/
            if(usuarioLogadoAtualizado.Bloqueado == true)
            {
              this.messageService.showNotify(MessageInfra.UsuarioBloquedo, EnumTipoMensagem.Alerta);
              this.router.navigateByUrl('/authentication/login');
              this.jwtService.destroyToken();
              return false;
            }

            if(usuarioLogadoAtualizado.Ativo == false)
            {
              this.messageService.showNotify(MessageInfra.UsuarioNaoAtivo, EnumTipoMensagem.Alerta);
              this.router.navigateByUrl('/authentication/login');
              this.jwtService.destroyToken();
              return false;
            }

            if(usuarioLogado.IdPerfil != usuarioLogadoAtualizado.UsuarioComplemento.Perfil.Id)
            {
              this.messageService.showNotify(MessageInfra.UsuarioPerfilDeAcessoAlterado, EnumTipoMensagem.Alerta);
              this.router.navigateByUrl('/authentication/login');
              this.jwtService.destroyToken();
              return false;
            }

            usuarioLogado.IdPerfil = usuarioLogadoAtualizado.UsuarioComplemento.Perfil.Id;

            /*PERFIL - ATUALIZAR OS DADOS DO USUARIO => ATIVO, BLOQUEADO E IDPERFIL*/
            window.localStorage.setItem('UsuarioLogado', JSON.stringify(usuarioLogado));

            var ExpiracaoMinutoSessao  = this.configsLoaderService.ExpiracaoMinutoSessao || 0;
            var NovaDataExpiracaoToken = new Date((new Date().setMinutes(new Date().getMinutes() + ExpiracaoMinutoSessao)));
            tokenDados.DataExpiracaoToken = NovaDataExpiracaoToken;
            window.localStorage.setItem('Token', JSON.stringify(tokenDados));
        });
      }
    }



    return true;
  }
}
